module.exports = __webpack_public_path__ + "static/media/curve_image2.757fa27c.jpg";